module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-MediumItalic-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-MediumItalic-webfont.eot
// module id = 692
// module chunks = 0